export { default as People } from './people/People';
export { default as UserList } from './UserList';
export { default as EditUser } from './EditUser';
export { default as ChangeAnalyst } from './ChangeAnalyst';
export { default as DashboardTable } from './DashboardTable';
export { default as OrganizationsTable } from './OrganizationsTable';
export { default as ParticipantsTable } from './ParticipantsTable';
export { default as AttendeeDashboard } from './AttendeeDashboard';
export { default as Header } from './Header';
export { default as Sidebar } from './Sidebar';
export { default as PrivateRoute } from './PrivateRoute';
export { default as DiscussionPoints } from './DiscussionPoints';
export { default as TranscriptHeader } from './TranscriptHeader';
export { default as ErrorBoundary } from './ErrorBoundary';



// WEBPACK FOOTER //
// ./components/organisms/index.js